export default __webpack_public_path__ + "static/media/image-nom-desktop.70f4a3e0.png";